import { Component, DoCheck, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SalesCategoryService } from '../../../service/sales-category/sales-category.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9162',
  templateUrl: './wa9162.component.html',
  styleUrls: ['./wa9162.component.scss']
})
export class Wa9162Component implements DoCheck, OnChanges {
  public componentTitle = 'WA9162:売上分類マスタ修正';
  public salescategoryId: number;
  public salescategoryCd: string;
  public salescategoryTx: FormControl;
  public creditaccCd: FormControl;
  public validation = validation;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private openwindow: boolean = false;
  @Input() sales: object = [];
  @Output() onSubmitClick = new EventEmitter();

  private isDelayHide = true;
  private salescategoryTxCls = '';
  private creditaccCdCls = '';

  constructor(private salescategoryService: SalesCategoryService, private commonService: CommonService, ) {
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    sessionStorage.removeItem('wa9162openwindow');
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    var salescategoryTx = this.salescategoryTx.value.trim();
    var creditaccCd = this.creditaccCd.value.trim();
    let errors = false;
    if (this.salescategoryTx.errors !== null) {
      this.salescategoryTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.creditaccCd.errors !== null) {
      this.creditaccCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    const updprogramCd: string = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.salescategoryService
      .put(this.salescategoryId, this.salescategoryCd, salescategoryTx, creditaccCd, updprogramCd)
      .then(outputJson => {
        sessionStorage.removeItem('wa9162openwindow');
        this.cancel();
        this.onSubmitClick.emit();
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9162openwindow') === 'open') {
      this.openwindow = true;
      this.isDelayHide = false;

      this.salescategoryTxCls = this.salescategoryTx.errors != null ? 'error' : this.salescategoryTx.value === this.sales['salescategoryTx'] ? '' : 'active';
      this.creditaccCdCls = this.creditaccCd.errors != null ? 'error' : this.creditaccCd.value === this.sales['creditaccCd'] ? '' : 'active';
    }
  }

  cancel() {
    this.errorInfo = '';

    sessionStorage.removeItem('wa9162openwindow');
    this.openwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.working = false;
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.sales) {
      const sales: object = this.sales;
      this.salescategoryId = sales['salescategoryId'];
      this.salescategoryCd = sales['salescategoryCd'];
      var salescategoryTx = sales['salescategoryTx'];
      var creditaccCd = sales['creditaccCd'];
      (this.salescategoryTx = new FormControl(salescategoryTx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salescategoryTx.maxLength)
      ])),
        (this.creditaccCd = new FormControl(creditaccCd, [
          Validators.pattern(validation.halfBlankOnly),
          Validators.pattern(validation.code39),
          Validators.maxLength(validation.creditaccCd.maxLength)
        ])),
        (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    }
  }

  changes(event) {
    this.errorInfo = '';

    if (!this.salescategoryTx.errors && !this.creditaccCd.errors) {

      if (this.sales['creditaccCd'] === event.target.value || this.sales['salescategoryTx'] === event.target.value) {
        this.working = false;
      } else {
        this.working = true;
      }
    } else {
      this.working = false;
    }

    if (event.target.value === '') {
      this.working = false;
    }

  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9162/wa9162.component.ts